module.exports = __webpack_public_path__ + "img/tour-32.fb5246a5.png";